/* * @Author: 曹俊杰 * @Date: 2022-05-10 18:47:09 * @Module: 三要素查询 风险排查 */
<template>
  <div class="inspiectSearch" :class="{ pageStyle: !ismode }">
    <div class="aliform" v-html="aliform" id="alipay_submit" v-show="false"></div>
    <el-form :model="form" ref="form" :rules="rules">
      <div class="box">
        <div class="title" v-show="!ismode">风险排查</div>
        <div class="row">
          <div class="row-left">选择排查内容：</div>
          <div class="row-right">
            <el-form-item style="margin-bottom: 0">
              <verification />
            </el-form-item>
          </div>
        </div>
        <div class="row" style="margin-top: 16px">
          <div class="row-left" style="line-height: 36px">填写查询信息：</div>
          <div class="row-right">
            <div class="form">
              <el-form-item prop="name" label="姓名">
                <el-input v-model="name" placeholder="请输入被查询姓名"></el-input>
              </el-form-item>
              <el-form-item prop="phone" label="手机号">
                <el-input v-model="phone" placeholder="请输入被查询人手机号"></el-input>
              </el-form-item>
              <el-form-item prop="idNumber" label="身份证号">
                <el-input
                  v-model="idNumber"
                  placeholder="请输入被查询人身份证号 "
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <el-button
          type="primary"
          @click="submit"
          :loading="loading"
          style="margin-left: 130px"
          class="button"
          >提交</el-button
        >
      </div>
    </el-form>
    <buy ref="buyRef" @onSubmit="onSubmit" />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import verification from "@/components/form/verification.vue";
import userinfo from "@/mixins/userinfo.js";
import buy from "@/components/buy.vue";
export default {
  components: { verification, buy },
  mixins: [userinfo],
  props: {
    ismode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const phoneValidator = (_, value, callback) => {
      if (this.$utils.test.mobile(value)) {
        return callback();
      } else {
        return callback(new Error("请输入正确的手机号"));
      }
    };
    const idNumberValidator = (_, value, callback) => {
      console.log(value);
      if (this.$utils.test.idCardStrict(value)) {
        return callback();
      } else {
        return callback(new Error("请输入正确的身份证号"));
      }
    };
    return {
      aliform: "",
      second: 0,
      loading: false,
      price: 20, //  三要素的价格  现在是写死 的
      rules: {
        name: [{ required: true, message: "请输入被查询姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入被查询人手机号", trigger: "blur" },
          { validator: phoneValidator, trigger: "blur" },
        ],
        idNumber: [
          {
            required: true,
            message: "请输入被查询人身份证号",
            trigger: "blur",
          },
          { validator: idNumberValidator, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState("fengxian", ["exposure", "contract", "verification"]),
    ...mapState("hetongqianshu", ["step"]),
    form() {
      return {
        name: this.name,
        phone: this.phone,
        idNumber: this.idNumber,
        paymentMethod: this.paymentMethod,
        exposure: this.exposure,
        contract: this.contract,
        verification: this.verification,
      };
    },
    name: {
      set(value) {
        this.setName(value);
      },
      get() {
        return this.$store.state.fengxian.name;
      },
    },
    phone: {
      set(value) {
        this.setPhone(value);
      },
      get() {
        return this.$store.state.fengxian.phone;
      },
    },
    idNumber: {
      set(value) {
        this.setIdNumber(value);
      },
      get() {
        return this.$store.state.fengxian.idNumber;
      },
    },
    paymentMethod: {
      set(value) {
        this.setPaymentMethod(value);
      },
      get() {
        return this.$store.state.fengxian.paymentMethod;
      },
    },
  },
  created() {
    const detectionId = this.$route.query.detectionId;
    if (!detectionId) {
      return;
    }
    this.getDetectionDetail(detectionId);
  },
  mounted() {
    if (!this.ismode) {
      this.clearData();
    }
  },
  methods: {
    ...mapActions("fengxian", [
      "setName",
      "setPhone",
      "setIdNumber",
      "setPaymentMethod",
      "setjieguo",
    ]),
    ...mapActions("hetongqianshu", ["setStep", "clearData"]),
    ...mapActions("fengxian", ["setFengxianVisible"]),
    async getDetectionDetail(detectionId) {
      const { data, status, info } = await this.$api.getDetectionDetail({ detectionId });
      if (status !== 200) {
        this.$message({
          type: "error",
          message: info,
        });
        return;
      }
      this.isSuccess(data);
    },
    async submit() {
      this.loading = true;
      try {
        await this.$refs.form.validate(); // 验证通过才继续往下走
      } catch (error) {
        this.loading = false;
        return; // 验证失败，退出函数
      }

      if (this.form.verification) {
        const chanpinList = [
          {
            name: "三要素报告",
            price: this.price,
          },
        ];
        this.$refs.buyRef.show({
          chanpinList,
        });
        console.log(this.ismode);
      } else {
        this.postDetection();
      }

      this.loading = false;
    },
    isSuccess(data) {
      if (this.ismode) {
        // this.$emit("success", data);
        this.setjieguo(data);
        this.setStep(this.step + 1);
        this.setFengxianVisible(false);
        setTimeout(() => {
          this.setFengxianVisible(true);
        }, 500);
      } else {
        this.$router.push({
          path: "/inspect/inspectList",
          query: {
            fileUrl: data.fileUrl,
          },
        });
      }
    },
    onSubmit(paymentMethod) {
      this.paymentMethod = paymentMethod;
      this.postDetection();
    },
    async postDetection() {
      const returnUrl = window.location.origin + window.location.pathname ;
      try {
        const { status, data, info } = await this.$api.postDetection({
          ...this.form,
          returnUrl,
        });
        if (status === 200) {
          this.$message({
            type: "success",
            message: info,
          });
          // 如果支付宝支付  跳转支付宝
          if (this.paymentMethod == 2) {
            this.aliform = data;
            this.$nextTick(() => {
              const forms = Array.from(document.forms);
              const alipayForm = forms.find((form) =>
                form.action.includes("alipay.com/gateway.do")
              );
              if (alipayForm) {
                alipayForm.submit();
              } else {
                console.warn("找不到支付宝表单");
              }
              // document.forms[0].submit(); //重点--这个才是跳转页面的核心,获取第一个表单并提交
            });
            this.paymentMethod = 1;
            return;
          }
          this.isSuccess(data);
          this.$refs.buyRef.close();
        } else {
          this.$message({
            type: "error",
            message: info,
          });
        }
        this.loading = false;
      } catch (e) {
        console.log("error", e);
        this.loading = false;
      }
    },
    noCode() {
      this.$alert("如无法获取验证码，请联系对接法务或客服。", "帮助", {
        confirmButtonText: "确定",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.inspiectSearch {
  padding: 16px 24px;
  .box {
    background: #fff;
    border-radius: 6px;

    .title {
      height: 60px;
      line-height: 60px;
      font-family: "Noto Sans SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      padding: 0 20px;
      padding-bottom: 16px;
    }

    .row {
      display: flex;

      .row-left {
        width: 130px;
        text-align: right;
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding-right: 14px;
      }

      .row-right {
        flex: 1;
        padding-right: 50px;
        .form {
          display: grid;
          grid-template-columns: repeat(2, 400px); // 两列，每列400px
          grid-template-rows: repeat(2, auto); // 两行，自动高度
          column-gap: 16px; // 列间距
          row-gap: 8px; // 行间距
          @include formStyle;
        }
      }
    }

    .button {
      @include buttonStyle;
      margin-top: 20px;
    }
  }
}
.pageStyle {
  padding: 0;
  .box {
    padding-bottom: 30px;
  }
}
</style>
